module.exports = __webpack_public_path__ + "img/cart_mixed.734dc60f.jpg";